import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Card, CardSection, Flex, IconSvg } from '@/lib/v2/components';
import { SectionHeader } from '@/lib/v2/examples/SectionHeader';
import { CreateIcon } from '@/lib/v2/icons/outline';
import { CampaignsIcon } from '@/lib/v2/icons/solid';

import {
  CreateEditCampaigns,
  DeleteCampaigns,
} from '@/src/modules/CampaignsModule/components/CampaignsModal';
import { SectionHeaderSubtitle } from '@/src/modules/CampaignsModule/components/SectionHeaderSubtitle';
import { useCampaignData } from '@/src/modules/CampaignsModule/hooks/useCampaignData';
import { useCampaignModal } from '@/src/modules/CampaignsModule/hooks/useCampaignModal';
import { useResetAtomOnUnmount } from '@/src/modules/CampaignsModule/hooks/useResetAtomOnUnmount';

import { TableContainer } from '@/modules/CampaignsModule/components/Campaigns/TableContainer';

const CampaignsMain = () => {
  const { t } = useTranslation();

  const { campaignList, loadingProcess, totalsCampaignList, filtersCount } = useCampaignData();
  const {
    handleOnOpenModal,
    handleOnCloseModal,
    toggleDeleteModal,
    toggleEditCreateCampaignModal,
  } = useCampaignModal();
  const { resetAtomProcess } = useResetAtomOnUnmount();

  useEffect(() => {
    return () => {
      resetAtomProcess();
    };
  }, []);

  return (
    <>
      <Card>
        <CardSection noPadding>
          <Flex column>
            <SectionHeader
              actionsButtons={
                <>
                  <Button
                    iconLeft={<IconSvg strokeColor="white" svgComponent={<CreateIcon />} />}
                    id="create-campaigns-button"
                    size="small"
                    onClick={handleOnOpenModal}
                  >
                    {t('CAMPAIGNS_MAIN.button')}
                  </Button>
                </>
              }
              icon={<IconSvg height="20px" svgComponent={<CampaignsIcon />} width="20px" />}
              subtitle={
                <SectionHeaderSubtitle
                  countFilters={filtersCount}
                  countRecordsPartial={totalsCampaignList.partial}
                  dataList={campaignList}
                  i18nKey="CAMPAIGNS_MAIN.search"
                  loading={loadingProcess}
                />
              }
              title={t('CAMPAIGNS_MAIN.title')}
              titleDetail={`${
                totalsCampaignList.total ? `(${totalsCampaignList.total || 0})` : ''
              }`}
            />
            <Flex column withGap gapSize="medium">
              <TableContainer />
            </Flex>
          </Flex>
        </CardSection>
      </Card>
      {toggleEditCreateCampaignModal && <CreateEditCampaigns onClose={handleOnCloseModal} />}
      {toggleDeleteModal && <DeleteCampaigns />}
    </>
  );
};

export default CampaignsMain;
